import AssemblyPaymentsTerminalsHtml from './assembly-payments.terminals.html';

export function AssemblyPaymentsTerminalsDirective () : ng.IDirective {
  const directive : ng.IDirective = {
    controller : 'AssemblyPaymentsTerminalsCtrl',
    restrict   : 'E',
    templateUrl: AssemblyPaymentsTerminalsHtml,
    scope      : {
      integrations: '=',
      terminals   : '='
    }
  };

  return directive;
}
